module.exports = __webpack_public_path__ + "img/Mondelez.4a9af1ea.jpg";